<template>
  <div class="progress-steps-container">
    <div v-for="({ step, label }, index) in steps" :key="index" class="step-container">
      <div class="step-number complete">
        <i class="uiw-font-close" style="color: var(--primary-color); font-size: 12px" />
      </div>
      <label :class="['step-label', ...(isStepFittedLabel(step) && ['fit-label'])].join(' ')" v-html="label" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressSteps',
  props: {
    steps: {
      type: Array,
      default: () => [
        {
          step: 1,
          label: 'View my shortlist',
          routes: ['dashboard']
        },
        {
          step: 2,
          label: 'Business details <span="new-line">& credit application</span>',
          routes: ['applications', 'businessDetails']
        },
        {
          step: 3,
          label: 'ID check & application review',
          routes: ['applications', 'approvals', 'approvals-waiting', 'application-on-hold', 'id-scan']
        },
        {
          step: 4,
          label: 'Review & sign lease documentation',
          routes: ['applications', 'reviewAndSignContract']
        }
        // {
        //   step: 5,
        //   label: 'Customise vehicle quotes'
        // },
        // {
        //   step: 6,
        //   label: 'Order vehicles '
        // }
      ]
    },
    activeSteps: {
      type: Array,
      default: () => [1]
    }
  },
  data() {
    return { currentActiveSteps: this.activeSteps };
  },
  watch: {
    activeSteps(newValue) {
      this.currentActiveSteps = newValue;
    }
  },
  methods: {
    isCompletedStep(step, label) {
      return step < this.currentActiveSteps[this.currentActiveSteps.length - 1] && label != 'View my shortlist';
    },
    isActiveStep(step, routes) {
      const currentPath = this.$route.name;

      return (
        routes.some((route) => currentPath === route && currentPath != 'applications') ||
        (currentPath === 'applications' && this.currentActiveSteps[this.currentActiveSteps.length - 1] == step)
      );
    },
    isStepFittedLabel(step) {
      const def = this.steps.find((s) => s.step === step);
      if (def && Object.prototype.hasOwnProperty.call(def, 'fitLabel')) {
        return !!def.fitLabel;
      }
      const fittedSteps = [2, 4];
      return fittedSteps.some((fittedStep) => fittedStep === step);
    }
  }
};
</script>

<style lang="sass" scoped>
.progress-steps-container
  border-radius: 10px
  border: 1px solid $grey-4
  background: $grey-1
  padding: 20px
  height: 100%
  display: flex
  flex-flow: row wrap
  justify-content: center

  .step-container
    display: flex
    flex-flow: row wrap
    width: 100%
    gap: 15px
    padding: 10px 0
    align-items: center
    .step-number
      display: flex
      justify-content: center
      align-items: center
      height: 40px
      width: 40px
      border: solid 1px $secondary
      border-radius: 40px
      color: white
      font-weight: 400
      font-size: 16px
      background-color: $secondary
      &.active
        background-color: $primary
        color: white
        border: 1px solid $primary
      &.complete
        background-color: $primary-background
        border: 1px solid $primary-background
        color: white
        img
          width: 12px
    .step-label
      max-width: 209px
      color: $grey-8
      font-weight: 700
      font-size: 16px
      line-height: 24px
      text-wrap: pretty
      span.new-line
        display:block

  @media (max-width: 1024px)
    max-width: 450px
    .step-container
      padding: 10px 0
      .step-number
        height: 28px
        width: 28px
        font-size: 14px
      .step-label
        max-width: 100%
        span.new-line
          display: inline-block

  @media (max-width: 394px)
    .step-container .step-label.fit-label
      max-width: 150px!important
  @media (max-width: 375px)
    .step-container .step-label
      max-width: 150px!important
</style>
